<div class="modal-content what-can-you-do-modal">
    <div class="modal-header">
        <figure>
            <img [src]="configService.config.pathImages +'parental/what-can-you-do.png'">
        </figure>
    </div>
    <div class="modal-body">
        <h4>{{'parental.screentime.daily.question' | translate}}</h4>
        <p [innerHTML]="modal_text | translate | safeHtml"></p>
        <a [href]="link_text" class="no-underline strong b2" target="_blank">{{'parental.read.more' | translate }}</a>
    </div>
    <div class="modal-footer pt-0">
        <p class="b3 uppercase">{{'parental.screentime.whatcanyoudo.additionally' | translate}}</p>
        <div class="d-flex">
            <a href="#" class="no-underline strong b2 mr-3" (click)="toAddSchedule()" *ngIf="listSchedule">{{'parental.screentime.setSchedule' | translate }}</a>
            <a href="#" class="no-underline strong b2" (click)="toAddDTL()" *ngIf="listDTL">{{'parental.screentime.setDTL' | translate }}</a>
        </div>
    </div>
</div>


